var _path, _path2, _g, _path3, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampfirePoints1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 80,
    viewBox: "0 10 60 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8081 86.1631C32.8081 86.1631 40.5815 85.1861 44.8883 81.5227C49.195 77.8594 53.9199 70.8975 53.3949 61.6183C52.87 52.3391 51.2101 52.1143 51.2101 52.1143C51.2101 52.1143 49.6131 55.7575 47.6173 54.7796C45.6215 53.8017 47.496 43.7815 43.9245 38.0401C41.2051 36.312 37.5163 33.7978 35.3951 30.4877C32.2491 25.5786 32.8081 18.6449 32.8081 18.6449C32.8081 18.6449 24.9761 27.318 23.6575 36.0022C22.4484 54.6874 23.774 58.2786 20.2005 58.2786C16.627 58.2786 15.999 49.5295 15.999 49.5295C15.999 49.5295 11.1665 57.4665 11.3768 63.2055C11.5871 68.9445 18.1016 78.1039 18.1016 78.1039L14.5301 77.251C14.5301 77.251 20.3057 86.1631 32.8081 86.1631Z",
    fill: "url(#paint0_radial)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8096 42.1659C13.8096 42.1659 16.9222 38.4983 17.6366 36.3539C18.3509 34.2094 18.6062 29.5265 18.249 29.8651C14.1667 33.589 13.8768 37.1025 13.8096 42.1659Z",
    fill: "#FF6320"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45,
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2718 87.1226C28.2718 87.1226 36.1079 89.403 42.81 83.2459C46.7634 79.6447 50.3276 75.5508 53.4318 71.0456L48.0696 72.5292C48.0696 72.5292 47.9655 66.4843 49.306 62.836C50.6466 59.1878 50.7491 56.3306 45.3526 60.5643C44.6592 61.1084 39.6136 59.5281 40.851 50.4078C42.0885 41.2875 34.2897 38.7727 29.6501 33.5303C29.6501 38.5476 24.1487 38.5495 23.6323 47.6709C23.1159 56.7923 22.3001 74.0122 10.8506 61.3536C10.8506 73.5539 19.8173 85.9822 28.2718 87.1226Z",
    fill: "#FE9A3D"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1337 84.9735C33.5311 86.7702 43.2978 81.4879 43.8179 73.8745C44.6633 69.5525 41.688 66.7489 39.2583 64.4124C32.6766 58.4353 27.4144 47.9574 29.1337 36.7988C16.3618 50.2036 31.7857 56.3314 24.637 65.7775C20.8327 68.8147 17.5192 66.4187 16.9911 68.4048C16.4631 70.3908 21.6329 84.5063 29.1337 84.9735Z",
    fill: "#FFB22D"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.121 84.7929C35.5938 84.7293 36.9658 79.7243 36.4107 77.0385C35.8555 74.3527 33.4738 70.8975 33.1962 67.6737C32.9186 64.45 33.7086 62.9233 33.7086 62.9233C33.7086 62.9233 30.8644 68.3178 30.2728 70.8505C29.6812 73.3833 30.6578 76.5781 29.2696 77.0385C27.8814 77.4989 25.5776 75.7336 26.1338 77.0385C26.69 78.3434 27.9234 84.8681 32.121 84.7929Z",
    fill: "#FFE840"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0007 73.4872C35.8748 73.4872 36.8939 66.0236 36.6325 62.779C36.3711 59.5344 32.7691 54.1793 33.0007 52.5566C33.2323 50.934 32.3612 60.0202 30.7918 61.3181C29.2224 62.6159 27.6537 63.0997 28.2637 66.0229C28.8737 68.9461 30.3935 73.4872 33.0007 73.4872Z",
    fill: "#FDFBE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 8.85059,
    y: 31.5303,
    width: 46.5812,
    height: 58.0052,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.443137 0 0 0 0 0.231373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 22.0488,
    y: 58.9233,
    width: 18.4812,
    height: 29.8702,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.25098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f",
    x: 15.1289,
    y: 39.3633,
    width: 34.543,
    height: 47.1239,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.4026 54.8409) rotate(-74.8621) scale(23.0991 16.8933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F87A1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F83D1F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampfirePoints1);
export default __webpack_public_path__ + "static/media/campfire-points-1.98585c5d2ec6948c74f3035e8ccfe218.svg";
export { ForwardRef as ReactComponent };